<template>
  <ButtonBase
    type="button"
    :class="rootClassName"
    @click.native="handleClick"
    >
    <slot />
  </ButtonBase>
</template>

<script>

import ButtonBase from '../ButtonBase'

export default {
  name: 'ToggleButton',

  components: { ButtonBase },

  props: {
    value: {
      type: undefined,
      default: ''
    }
  },

  inject: [ 'ToggleButtonGroup' ],

  methods: {
    handleClick () {
      this.ToggleButtonGroup.handleChange(this.value)
    }
  },

  computed: {
    selected () {
      const { value } = this.ToggleButtonGroup

      if (Array.isArray(value)) {
        return value.includes(this.value)
      }

      return value === this.value
    },

    rootClassName () {
      const size =
        this.ToggleButtonGroup.size !== 'medium' &&
        this.ToggleButtonGroup.size

      return [
        'ToggleButton',
        {
          [`size-${size}`]: size,
          conjoined: this.ToggleButtonGroup.conjoined,
          selected: this.selected
        }
      ]
    }
  }
}

</script>

<style scoped>

.ToggleButton {
  display: inline-flex;
  flex-grow: 1;
  align-items: center;
  justify-content: center;
  outline: none;
  height: 40px;
	@apply
    rounded
    text-sm
		my-0
		mx-1
    text-secondary
		border
		border-solid
		border-dull;
}

.ToggleButton:first-child {
  margin-left: 0;
}

.ToggleButton:last-child {
  margin-right: 0;
}

.conjoined {
  margin: 0;
}

.conjoined:not(:first-child) {
  margin-left: -1px;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.conjoined:not(:last-child) {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.selected {
  @apply
		text-primary
}

.size-small {
  height: 32px;
  padding: 0px 8px;
}

.size-large {
  height: 56px;
  padding: 0px 16px;
}

.size-xl {
  height: 80px;
  padding: 0px 16px;
}

.size-xxl {
  height: 120px;
  padding: 0px 16px;
}

</style>
